import { gql } from '@apollo/client';

import { subjectsTreeFragment } from '../fragments';

export default gql`
  mutation UpdateSubject($courseId: String!, $subjectId: String!, $input: UpdateSubjectInput!) {
    subjects(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "Subject", path: "courses/{args.courseId}/subjects/{args.subjectId}", method: "PUT") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
